// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AiProcessOut = zod.object({
  "capability": zod.string(),
  "description": zod.string(),
  "has_prompt": zod.boolean(),
  "key": zod.string(),
  "max_output_tokens": zod.union([zod.int(),zod.null()]),
  "model_key": zod.union([zod.string(),zod.null()]),
  "module": zod.string(),
  "name": zod.string(),
  "problem": zod.union([zod.string(),zod.null()])
});

export type AiProcessOut = zod.input<typeof AiProcessOut>;
export type AiProcessOutOutput = zod.output<typeof AiProcessOut>;
